import classes from "./AboutUs.module.scss";
import GetInTouch from "../../Components/GetInTouch/GetInTouch";
import { ReactComponent as TopWave } from "../../assets/icons/topWave.svg";
import { ReactComponent as DownWave } from "../../assets/icons/down_wave.svg";
import Quote from "../../assets/icons/Quote";
import { useEffect } from "react";
import Leadership from "./Leadership/Leadership";

function AboutUs() {
  useEffect(() => {
    window.scrollTo(0, 0);

    // Set the tab name
    document.title =
      "Net-Zero Transitions with Custom, Data-Driven SaaS Solutions";

    // Set the meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Navigate your decarbonization journey with our tech-driven SaaS platforms. Simplify and automate net-zero transitions with expert insights and global standards."
      );
    } else {
      // If the meta tag doesn't exist, create it
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content =
        "Navigate your decarbonization journey with our tech-driven SaaS platforms. Simplify and automate net-zero transitions with expert insights and global standards.";
      document.head.appendChild(meta);
    }

    // Clean up (if necessary) when component unmounts
    return () => {
      document.title = "Default Title"; // Restore the default title
    };
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <img className={classes["header-img"]} src={"https://se-website-image.s3.ap-south-1.amazonaws.com/about-us/header-img.jpeg"} alt="About Us" />

        <div className={classes.title}>About Us</div>
      </div>

      <div className={classes.story}>
        <div className={classes.title}>Our Story</div>

        <p className={classes.text}>
          At Sustainability Economics. ai, we’re redefining the future by driving advancements in both AI and clean energy — two forces shaping tomorrow’s world.
        </p>
        <div className={classes['space']}></div>
        <p className={classes.text}>
          We’re building intelligent energy solutions to help high-emission industries achieve net-zero goals. At the same time, we’re developing AI infrastructure and services, designed to power next-generation applications and data centers.
        </p>
        <div className={classes['space']}></div>
        <p className={classes.text}>
          Our aim is to create a future where AI innovation and clean energy work hand in hand to enable smarter systems, greener industries, and lasting impact.
        </p>
        <div className={classes["top-wave-container"]}>
          <TopWave />
        </div>
        <div className={classes["bottom-wave-container"]}>
          {/* <DownWave /> */}
        </div>
      </div>

      <div className={classes["ceo-details"]}>
        <div style={{ width: "35%" }}>
          <img src={"https://se-website-image.s3.ap-south-1.amazonaws.com/about-us/people/ceo.png"} alt="ceo" className={classes.ceoImg} />
        </div>

        <div className={classes.info} >
          <div className={classes.quote}><Quote className={classes["custom-quote"]} /></div>
          <div className={classes["main-text"]}>
            The future lies in uniting <br />
            clean energy and  <br />
            intelligent <span>AI technology.</span>

          </div>
          <p className={classes["ceo-name"]}>Kasu Venkata Reddy, Co-Founder & CEO</p>
        </div>
      </div>



      <div className={classes['mission-vision-container']}>
        <div className={classes['vision-container']}>
          <div className={classes['vision-text-container']}>
            <div className={classes['vision-header']}>
              Our Vision
            </div>
            <div className={classes['vision-desc']}>
              To lead a global shift in converging AI and clean energy for a high tech and green future.
            </div>
          </div>
          <div className={classes['vision-img']}>
            <img src={"https://se-website-image.s3.ap-south-1.amazonaws.com/about-us/vision.png"} alt="" className={classes["image-vision"]} />
          </div>
        </div>
        <div className={classes['mission-container']}>
          <div className={classes['mission-img']}>
            <img src={"https://se-website-image.s3.ap-south-1.amazonaws.com/about-us/mission.png"} alt="" className={classes["image-mission"]} />
          </div>
          <div className={classes['mission-text-container']}>
            <div className={classes['mission-header']}>
              Our Mission
            </div>
            <div className={classes['mission-desc']}>
              To empower industries by offering innovative AI-driven infrastructure, powered by sustainable energy.
            </div>
          </div>

        </div>

      </div>

      <Leadership />


      <GetInTouch />
    </div>
  );
}

export default AboutUs;
